import { collection, doc, getDocs, limit, orderBy, query, setDoc } from "firebase/firestore";
import { db } from "../firebase";
import { firebaseDataConverter } from "./Converters/FirebaseConverter";
import { ProductKeyTransfer, ProductKeyTransferFromDbMapper, ProductKeyTransferToDbMapper } from "../models/ProductKeyTransfer";
import { ProductKeyTransferDb } from "./models/ProductKeyTransferDb";

/* An append-only record of product keys being moved between products. Each key also
   carries its own origin fields, but this is the event history: who moved what,
   where, and when. */
class ProductKeyTransferService {
    private static instance: ProductKeyTransferService | null = null;

    private static tableName: string = "productKeyTransfer";
    public static getInstance(): ProductKeyTransferService {
        if (this.instance === null) {
            this.instance = new ProductKeyTransferService();
        }
        return this.instance;
    }

    public async addTransferAsync(transfer: ProductKeyTransfer): Promise<void> {
        var mappedDb = ProductKeyTransferToDbMapper(transfer);
        await setDoc(doc(db, ProductKeyTransferService.tableName, transfer.guid).withConverter<ProductKeyTransferDb>(firebaseDataConverter), mappedDb);
    }

    public async getTransfersAsync(maximumNumberOfTransfers: number): Promise<ProductKeyTransfer[]> {
        const q = query(collection(db, ProductKeyTransferService.tableName),
            orderBy("transferredDate", "desc"),
            limit(maximumNumberOfTransfers)).withConverter<ProductKeyTransferDb>(firebaseDataConverter);
        const documents = await getDocs(q)
        const mapped = documents.docs.map(doc => {
            var data = doc.data()
            return ProductKeyTransferFromDbMapper(data);
        });
        return mapped;
    }
}

const useProductKeyTransferService = () => {
    return ProductKeyTransferService.getInstance();
}

export default useProductKeyTransferService;
